/* Stylesheet */

@keyframes fade-in {
  from {
    opacity: 0;
    scale: (0.75);
  }
  to {
    opacity: 1;
    scale: (1);
  }
}

.chart_tooltip {
  padding: 12px;
  position: absolute;
  background: var(--ion-color-hover-label);
  border-radius: 8px;
  white-space: nowrap;
  animation: fade-in 0.4s ease-out;

  .content_container {
    display: flex;
    align-items: center;
    color: var(--ion-color-text-secondary);
    line-height: 2;

    .color {
      margin: 0px 12px 0px 0px;
      height: 12px;
      width: 12px;
      border-radius: 12px;
    }

    .key {
      font-weight: 500;
      margin-right: 8px;
    }
  }

  /* Arrow (bottom) */
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 21px;
    border-width: 8px;
    border-style: solid;
    border-color: var(--ion-color-hover-label) transparent
      transparent transparent;
  }
}

.top {
  margin: 32px 0px 0px 0px;
  transform: translateY(100%);

  &.top::after {
    top: auto;
    bottom: 100%;
    border-color: transparent transparent
      var(--ion-color-hover-label) transparent;
  }
}
